import { useState, useRef, useEffect } from "react";
import { Globe } from "lucide-react";

const languages = [
  { code: "no", name: "Norsk", flag: "🇳🇴" },
  { code: "en", name: "English", flag: "🇬🇧" }
];

export default function LanguageSwitcher({ currentLang, onChangeLang }) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const currentLanguage = languages.find(l => l.code === currentLang) || languages[0];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-3 py-2 rounded-full bg-white/80 hover:bg-white border border-border/50 transition-colors text-sm"
        data-testid="language-switcher"
      >
        <Globe className="w-4 h-4 text-muted-foreground" />
        <span>{currentLanguage.flag}</span>
        <span className="hidden sm:inline text-muted-foreground">{currentLanguage.name}</span>
      </button>
      
      {isOpen && (
        <div className="absolute top-full left-0 mt-2 bg-white rounded-xl shadow-lg border border-border/50 overflow-hidden z-50 min-w-[140px]">
          {languages.map((lang) => (
            <button
              key={lang.code}
              onClick={() => {
                onChangeLang(lang.code);
                setIsOpen(false);
              }}
              className={`w-full flex items-center gap-3 px-4 py-3 hover:bg-muted/50 transition-colors text-left ${
                currentLang === lang.code ? "bg-muted/30" : ""
              }`}
            >
              <span className="text-lg">{lang.flag}</span>
              <span className="text-sm text-foreground">{lang.name}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
